import axios from "axios";
import { PPD_CENSUS_DATA, PPD_CENSUS_SAVE, SET_ERROR } from "../../types";

export const getCensusRecords = (company, payload) => {
    return async dispatch => {
        await axios.get(`api/ppd/census-records/${company}`, {
            params: payload
        }).then(res => {
            dispatch({
                type: PPD_CENSUS_DATA,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const saveCensusRecords = (payload) => {
    return async dispatch => {
        await axios.post('api/ppd/save-census-records', payload).then(res => {
            dispatch({
                type: PPD_CENSUS_SAVE,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}